<template>
  <div>
    <div class="caption">
      <div class="title">{{$t('query.result.other.news')}}</div>
      <router-link class="more line" :to="{name: 'News'}">{{$t('query.result.other.more')}}</router-link>
    </div>
    <ul>
      <li v-for="(item, index) in list" :key="'related-news-' + index">
        <router-link class="none" :to="{name: 'NewsShow', params: {id: item.id}}">{{item.title}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'RelatedNews',
  computed: {
    ...mapDataState({
      'list': state => state.relatedNews
    })
  },
  updated () {
    this.$nextTick(() => {
      this.$parent.refresh && this.$parent.refresh()
    })
  }
}
</script>
<style scoped>
  .caption{
    margin-bottom: 18px;
    position: relative;
  }
  .caption .title{
    color: #333;
    /*font-size: 12px;*/
    font-size: 14px;
    font-weight: bold;
  }
  .caption .more{
    /*font-size: 1.1rem;*/
    font-size: 1.3rem;
    color: #999;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .caption .more:after{
    background-color: #999;
  }
  ul li{
    margin-bottom: 10px;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li a{
    color: #333;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  /*ul li a:hover{*/
    /*text-decoration: underline;*/
  /*}*/
  /*ul li a:after{*/
    /*width: 0;*/
    /*height: 0;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/query/common/RelatedNews.vue